import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ApiRequest, Filter, FilterComposit, FilterPredicate, Sort, SortCondition, PageInfo, ApiResponse } from '../model/api-request';

import { tap } from 'rxjs/operators/tap';
import { catchError, map } from 'rxjs/operators';

// ===========================================
// Get Multiple
// filterItems => operation values...
// ===========================================
// IsLessThan = 0
// IsLessThanOrEqualTo = 1
// IsEqualTo = 2
// IsNotEqualTo = 3
// IsGreaterThanOrEqualTo = 4
// IsGreaterThan = 5
// StartsWith = 6
// EndsWith = 7
// Contains = 8
// IsContainedIn = 9
// DoesNotContain = 10
// IsNullOrGreaterThan = 11
// ==============================================
// v2
// ==============================================
// IsEqualTo
// IsNotEqualTo
// IsGreaterThan
// IsGreaterThanOrEqualTo
// IsLessThan
// IsLessThanOrEqualTo
// Contains


export abstract class GenericCrudService<T> extends BehaviorSubject<any>{

  constructor(
    protected http: HttpClient,
    protected url: string
  ) {
    super({});
  }

  private data: any = {};
  public useLookups = false;

  public getAll(apiRequest: ApiRequest) {

    this.getMultiChoice(apiRequest)
      .pipe(
        tap(data => {
          this.data = data;
        })
      )
      .subscribe((result => {
        super.next(result);
      }));
  }

  private getMultiChoice(apiRequest) {
    if (this.useLookups == false) {
      return this.getMultiple(apiRequest);
    } else {
      return this.getMultipleWithLookups(apiRequest);
    }
  }

  public reset() {
    this.data = {};
  }

  public getMultiple(request: ApiRequest): Observable<any> {
    console.log(request);
    return this.http.post(`${this.url}/GetMultiple`, request).pipe(
      map(val => {
        return val
      }),
      catchError(error =>  {
        return of(error);
      })
    ) as Observable<any>;
  }

  public getMultipleWithLookups(request: any): Observable<T[]> {
    return this.http.post(`${this.url}/GetMultipleWithLookups`, request) as Observable<T[]>;
  }

  public get(id: number): Observable<T> {
    return this.http.get(`${this.url}/${id}`) as Observable<T>;
  }

  public create<T>(objToCreate: T): Observable<T> {
    return this.http.post<T>(`${this.url}/Create`, objToCreate);
  }

  public read<T>(): Observable<T | T[]> {
    return this.http.get<T | T[]>(`${this.url}/Read`);
  }

  public update<T>(id: number, objToUpdate: T): Observable<T> {
    return this.http.put<T>(`${this.url}/Change${id}`, objToUpdate) as Observable<T>;
  }

  public delete<T>(id: number): Observable<T> {
    return this.http.delete<T>(`${this.url}/${id}`);
  }

  public buildRequest(skip: number, take: number) {
    var pageNumber = (skip + take) / take;
    var apiRequest = new ApiRequest();
    var filterPredicate1: Array<FilterPredicate>;
    var filterPredicate2: Array<FilterPredicate>;
    var filterCompositArray: Array<FilterComposit>;
    var sortConditionArray: Array<SortCondition>;
    var sort1: Sort;

    sortConditionArray = [new SortCondition('name','Descending')];
    filterPredicate1 = [new FilterPredicate('name', 'string', 'Air Canada','IsEqualTo')];
    filterPredicate2 = [new FilterPredicate('departmentId', 'integer', '56','IsEqualTo')];

    filterCompositArray = [new FilterComposit(filterPredicate1, 'Or'), new FilterComposit(filterPredicate2,'Or')];

    apiRequest.filter = new Filter(filterCompositArray, "And");
    sort1.conditions = sortConditionArray;
    apiRequest.sort = sort1;

    apiRequest.pageInfo = new PageInfo(0, pageNumber, take);
    return apiRequest;
  }

  public buildRequestForPage(sort: Sort, filter: Filter, pageInfo: PageInfo) {
    let apiRequest = new ApiRequest();
    apiRequest.filter = filter;

    apiRequest.sort = sort;
    apiRequest.pageInfo = pageInfo;
    return apiRequest;
  }

}
